import { HTMLElementBase } from './HTMLElementBase';
import {HTMLElement} from "./HTMLElement";
export class HTMLObjectElement extends HTMLElement { constructor(tagName: string = 'OBJECT', ownerDocument?: any) { super(tagName, ownerDocument); } }
